<nav class="navbar navbar-expand-md navbar-light bg-light">
    <div class="container-fluid">
        <span class="col-4">
            <a class="navbar-brand col-4" href="#">
                <img class="logo-pfg" src="assets/LOGO_PFG_white.png" alt="logo-play-for-good">
            </a>
        </span>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02"
                aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse col-8" id="navbarTogglerDemo02">
            <ul class="navbar-nav col-sm-12 col-md-6">
                <li class="nav-item">
                    <a class="nav-link" href="#about">A propos</a>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#list-editions" id="navbarDropdown" role="button"
                       data-bs-toggle="dropdown" aria-expanded="false">Editions</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li><a class="dropdown-item" href="#edition-flappy">Edition Flappy Bird</a></li>
                        <li><a class="dropdown-item" href="#edition-riot">Edition LOL x TFT x LOR</a></li>
                    </ul>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#contact">Contact</a>
                </li>
            </ul>
            <ul class="navbar-nav col-sm-12 col-md-6 icon-log">
                <li class="nav-item">
                    <a class="nav-link" href="#">
                        <fa-icon [icon]="faUser"></fa-icon>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</nav>
